import attachment from './attachment';
import auth from './auth';
import car from './car';
import carQueue from './car-queue';
import closed from './closed';
import menuConfig from './menu-config';
import pageConfig from './page-config';
import store from './store';
import user from './user';
import userGroup from './user-group';

export const api = {
    attachment,
    auth,
    car,
    carQueue,
    closed,
    menuConfig,
    pageConfig,
    store,
    user,
    userGroup,
};
